<template>
  <component :is="tag" :class="className" :style="style">
	  <OnClickOutside @trigger="away">
		  <span @click="toggle = !toggle">
			  <slot name="toggle"></slot>
		  </span>
	  </OnClickOutside>
	  <div v-if="toggle">
      <slot></slot>
    </div>
  </component>
</template>

<script>
import classNames from 'classnames'
import mdbClassMixin from '@/mixins/mdbvue/mdbClassMixin'
import { OnClickOutside } from '@vueuse/components'

const Dropdown = {
	components: {
		OnClickOutside,
	},
	props: {
		tag: {
			type: String,
			default: 'div'
		},
		show: {
			type: Boolean
		},
		btnGroup: {
			type: Boolean
		},
		dropup: {
			type: Boolean,
			default: false
		},
		dropright: {
			type: Boolean,
			default: false
		},
		dropleft: {
			type: Boolean,
			default: false
		},
		split: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			toggle: false
		}
	},
	mixins: [mdbClassMixin],
	methods: {
		away () {
			this.toggle = false
		}
	},
	computed: {
		className () {
			return classNames(
				this.btnGroup ? 'btn-group' : 'dropdown',
				this.show && 'show',
				this.dropup && 'dropup',
				this.dropright && 'dropright',
				this.dropleft && 'dropleft',
				this.mdbClass
			)
		},
		style () {
			return {
				'margin-left': this.split && '-0.3rem'
			}
		}
	}
}

export default Dropdown
export { Dropdown as mdbDropdown }
</script>

<style scoped>
.dropdown {
  display: inline-block;
}
</style>

<style>
.navbar .dropdown-menu a:hover {
  color: inherit !important;
}
</style>
